import React from "react";
import { Progress } from "@ui/progress";

interface Props {
  value: number;
  bgStyle?: string;
  prgresserBg?: string;
  prgresserBgColor?: string;
  height?: string;
  borderStyle?: string;
}

export const ProgressBar = ({
  value,
  bgStyle = "bg-[#B5B5B5]",
  prgresserBg = "bg-primary",
  height = "h-2",
  borderStyle,
  prgresserBgColor,
}: Props) => {
  return (
    <Progress
      value={value}
      className={`rtl:rotate-180 ${bgStyle} ${height} ${borderStyle}`}
      prgresserBg={prgresserBg}
      prgresserBgColor={prgresserBgColor}
    />
  );
};
